module.exports = __webpack_public_path__ + "img/image134.4fa13a26.png";